// 赵阳
// 新用户引导

const routers = [
  {
    path: '/speak-now',
    name: 'speakNow',
    component: () =>
        import(/* webpackChunkName: "speak" */ './pages/speak'),
    meta: {
      waitUserInfo: true,
    }
  },
  {
    path: '/speak-add',
    name: 'speakAdd',
    component: () =>
        import(/* webpackChunkName: "speak" */ './pages/speak/create-add'),
    meta: {
      waitUserInfo: true,
    }
  },
  {
    path: '/user-guide',
    name: 'userGuide',
    component: () =>
        import(/* webpackChunkName: "user-guide" */ './pages/user-guide'),
    meta: {
      waitUserInfo: true,
    }
  },
  {
    path: '/feed-detail',
    name: 'feedDetail',
    component: () =>
        import(/* webpackChunkName: "feed-detail" */ './pages/feed-detail'),
    meta: {
      waitUserInfo: true,
    }
  },
  {
    path: '/customer',
    name: 'customer',
    component: () =>
        import(/* webpackChunkName: "customer" */ './pages/customer'),
    meta: {
      waitUserInfo: true,
    }
  },
  {
    path: '/customer-list',
    name: 'customerList',
    component: () =>
        import(/* webpackChunkName: "customer" */ './pages/customer/customer-list'),
    meta: {
      waitUserInfo: true,
    }
  },
  {
    path: '/valentine-day',
    name: 'valentineDay',
    component: () =>
        import(/* webpackChunkName: "activities" */ './activities/valentine-day'),
    meta: {
      // waitUserInfo: true,
    }
  }
];

export default routers;
